module.exports = __webpack_public_path__ + "static/media/CALLS-PitchOn.31dc6520.svg";